"use client";

import { usePathname } from "next/navigation";
import { ReactNode, useEffect } from "react";
import { useMediaQuery } from "usehooks-ts";

export default function Script(): ReactNode {
  const pathname = usePathname();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    if (!isDesktop) return;

    const header = document.getElementById("header");
    if (!header) return;

    if (pathname.startsWith("/checkout")) {
      header.style.display = "none";
      header.style.visibility = "hidden";
      header.setAttribute("aria-hidden", "true");
    } else {
      header.style.display = "flex";
      header.style.visibility = "visible";
      header.setAttribute("aria-hidden", "false");
    }
  }, [isDesktop, pathname]);

  return null;
}
